<!-- Read once in each sign-in, not on every page (FR-5.48): the alerts as they first showed -->
<div class="sr-only" aria-live="polite" data-testid="sync-alerts-announcement">
  @if (announced.length > 0) {
    <p>{{ 'sync.alerts.heading' | translate }}</p>
    @for (alert of announced; track alert.projectId) {
      <p>{{ alert.sentence.key | translate: alert.sentence.params }} {{ 'sync.alerts.held' | translate: {count: alert.held} }}</p>
    }
  }
</div>

<div [class]="alerts.length > 0 || status ? 'ml-4 mr-8 mt-8 rounded-lg border border-surface-200 p-4' : ''" data-testid="sync-alerts">
  @if (alerts.length > 0 || status) {
    <section aria-labelledby="sync-alerts-heading">
      <!-- Takes focus when an action removed the button that had it -->
      <h2 #heading id="sync-alerts-heading" tabindex="-1" class="flex items-center gap-2 font-semibold text-color" [class.mb-3]="alerts.length > 0">
        <i class="pi pi-exclamation-triangle text-error" aria-hidden="true"></i>{{ 'sync.alerts.heading' | translate }}
      </h2>
      @if (alerts.length > 0) {
        <ul class="flex flex-col gap-3">
          @for (alert of alerts; track alert.projectId) {
            <li class="flex flex-wrap items-center gap-x-4 gap-y-2" [attr.data-alert]="alert.projectId">
              <span class="text-color" data-testid="alert-text">{{ alert.sentence.key | translate: alert.sentence.params }}</span>
              @if (alert.archivedAt) {
                <span class="text-sm text-color" data-testid="alert-archived-at">
                  {{ 'sync.linkCheck.archivedOn' | translate }} <time [attr.datetime]="alert.archivedAt">{{ alert.archivedAt | dateTime }}</time>
                </span>
              }
              <span class="text-sm text-color" data-testid="alert-held">{{ 'sync.alerts.held' | translate: {count: alert.held} }}</span>
              <a [routerLink]="['/projects', alert.projectId, 'sync-health']" [queryParams]="{tab: alert.tab}" class="text-sm text-primary underline" data-testid="alert-open">
                {{ 'sync.alerts.open' | translate }}<span class="sr-only"> {{ 'sync.alerts.forProject' | translate: {project: alert.project} }}</span>
              </a>
              @if (alert.beingSent) {
                <span class="text-sm font-medium text-color" data-testid="alert-sending">{{ 'sync.alerts.sending' | translate }}</span>
              } @else if (alert.canSend) {
                <!-- The count is in the accessible name (FR-5.48) -->
                <button #sendButton pButton type="button" size="small" data-testid="alert-send" (click)="confirmSend(alert, sendButton)">
                  <i class="pi pi-send" aria-hidden="true"></i>
                  <span>{{ 'sync.held.send' | translate: {count: alert.held} }}<span class="sr-only"> {{ 'sync.alerts.forProject' | translate: {project: alert.project} }}</span></span>
                </button>
              }
              <button pButton type="button" size="small" severity="secondary" [text]="true" data-testid="alert-hide" [attr.aria-label]="'sync.alerts.hideName' | translate: {project: alert.project}" (click)="hide(alert)">
                {{ 'sync.alerts.hide' | translate }}
              </button>
            </li>
          }
        </ul>
      }
    </section>
  }
  <!-- Always there, so each action's result is announced -->
  <p class="text-sm font-medium text-color" [class.mt-3]="status && alerts.length > 0" aria-live="polite" data-testid="sync-alerts-status">
    @if (status; as current) {
      @if (current.kind === 'sent') {
        {{ current.project }}: {{ current.result.key | translate: current.result.params }}
      } @else {
        {{ 'sync.alerts.hidden' | translate: {project: current.project} }}
      }
    }
  </p>
</div>

<p-dialog
  [(visible)]="confirming"
  [modal]="true"
  [header]="'sync.alerts.confirmHeader' | translate: {project: confirmed?.project ?? ''}"
  [closeAriaLabel]="'sync.retry.close' | translate"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '32rem', 'max-width': 'calc(100vw - 2rem)' }"
  (onHide)="dialogClosed()"
>
  <p>{{ 'sync.held.confirmMessage' | translate: {count: confirmed?.held ?? 0} }}</p>
  <ng-template #footer>
    <button pButton type="button" severity="secondary" [outlined]="true" data-testid="alert-send-cancel" (click)="cancelSend()">
      {{ 'sync.held.confirmReject' | translate }}
    </button>
    <button pButton type="button" data-testid="alert-send-confirm" (click)="send()">
      {{ 'sync.held.confirmAccept' | translate }}
    </button>
  </ng-template>
</p-dialog>
